import Stack from '@mui/material/Stack';
import { SecondaryButton } from 'sharedComponents/Buttons';
import { Vacancy } from 'types/connectTypes';
import { VacanciesSectionProps } from '../types';
import { VacancyRow } from './VacancyRow';
import { NoVacanciesSection } from './VacancyRow';
import ArrowForwardIosOutlined from '@mui/icons-material/ArrowForwardIosOutlined';
import { moreInfoOnClickHandler } from 'features/Connect/features/ExpressInterest/utils';
import { useTheme } from '@mui/material';
import { useConnectContext } from 'features/Connect/features/Context/ConnectContextProvider';

export const VacanciesSectionButtonRows: React.FC<VacanciesSectionProps> = ({
  vacancies,
  school,
}) => {
  const { connectContextActions } = useConnectContext();
  const theme = useTheme();
  if (vacancies?.length === 0) {
    return <NoVacanciesSection />;
  }

  return (
    <>
      <Stack direction={'column'} width={'100%'}>
        {vacancies?.map((vacancy: Vacancy, index) => {
          return (
            <SecondaryButton
              key={`${vacancy.uuid}_${index}`}
              onClick={() => moreInfoOnClickHandler(school, connectContextActions, vacancy.uuid)}
              sx={{
                margin: '4px 0px',
                justifyContent: 'space-between',
                textAlign: 'left',
                border: '1px solid #EAECF0',
                borderRadius: '8px',
                width: '100%',
                padding: '0px 12px 0px 0px',
                '&:hover': {
                  backgroundColor: theme.palette.white.medium,
                  border: `1px solid ${theme.palette.black.dark}`,
                },
                '& .MuiTouchRipple-root': {
                  color: theme.palette.gray.mediumLight,
                },
              }}
              dataTestId="connect-job-card"
            >
              <VacancyRow vacancy={vacancy} />
              <ArrowForwardIosOutlined
                fontSize="small"
                sx={{ color: '#667085', alignSelf: 'center' }}
              />
            </SecondaryButton>
          );
        })}
      </Stack>
    </>
  );
};
